function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRefCallback } from '@bydesign-ui/hooks';
import React, { useCallback } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Switch } from '../../../components/switch';
export var ActiveTab;

(function (ActiveTab) {
  ActiveTab["SOURCE"] = "source";
  ActiveTab["TARGET"] = "target";
})(ActiveTab || (ActiveTab = {}));

function RangeDateItem(props) {
  var value = props.value,
      disabled = props.disabled,
      active = props.active,
      onTabChange = props.onTabChange,
      activeTag = props.activeTag,
      extra = _objectWithoutProperties(props, ["value", "disabled", "active", "onTabChange", "activeTag"]);

  var cls = usePrefixCls('compare-range-date-item', {
    active: active,
    disabled: disabled
  });
  var textCls = usePrefixCls('compare-range-date-text', {
    placeholder: !value[0]
  });
  var divider = usePrefixCls('compare-range-date-divider');
  var start = useLocale('date-picker.start');
  var end = useLocale('date-picker.end');
  var onTabChangeCallback = useRefCallback(onTabChange);
  var handleClick = useCallback(function () {
    if (disabled || active) {
      return;
    }

    onTabChangeCallback(activeTag);
  }, [activeTag, disabled, active]);
  return React.createElement("div", Object.assign({}, extra, {
    className: cls,
    onClick: handleClick
  }), React.createElement("span", {
    className: textCls
  }, value[0] || start), React.createElement("span", {
    className: divider
  }, "~"), React.createElement("span", {
    className: textCls
  }, value[1] || end));
}

export function CompareRangeDateHeader(props) {
  var value = props.value,
      onCompareChange = props.onCompareChange,
      onTabChange = props.onTabChange,
      active = props.active,
      _props$comparisonSwit = props.comparisonSwitch,
      comparisonSwitch = _props$comparisonSwit === void 0 ? true : _props$comparisonSwit;
  var source = value.source,
      isCompare = value.isCompare,
      target = value.target;
  var cls = usePrefixCls('compare-range-date-header');
  var headerLeft = usePrefixCls('compare-range-date-header-left');
  var headerRight = usePrefixCls('compare-range-date-header-right');
  var headerDivider = usePrefixCls('compare-range-date-header-divider');
  var headerSwitchCls = usePrefixCls('compare-range-date-header-switch');
  var onCompareChangeCallback = useRefCallback(onCompareChange);
  var onTabChangeCallback = useRefCallback(onTabChange);
  var locale = useLocale('date-comparison.compare');

  var comparePart = function comparePart() {
    if (!isCompare) {
      return null;
    }

    return React.createElement(React.Fragment, null, React.createElement("span", {
      className: headerDivider
    }, locale), React.createElement(RangeDateItem, {
      onTabChange: onTabChangeCallback,
      value: target,
      active: active === ActiveTab.TARGET,
      activeTag: ActiveTab.TARGET
    }));
  };

  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: headerLeft
  }, React.createElement(RangeDateItem, {
    onTabChange: onTabChangeCallback,
    value: source,
    active: active === ActiveTab.SOURCE,
    activeTag: ActiveTab.SOURCE
  }), comparePart()), comparisonSwitch && React.createElement("div", {
    className: headerRight
  }, React.createElement("span", null, locale), React.createElement(Switch, {
    className: headerSwitchCls,
    disabled: !value.source.length,
    size: "sm",
    checked: isCompare,
    onValueChange: onCompareChangeCallback
  })));
}